import { useContext } from "react";
import { GAContext } from "../providers/GAProvider";

export const useGAEventLogger = () => {
  const context = useContext(GAContext);

  if (context === null) {
    throw new Error("useGAEventLogger must be used within a GAProvider");
  }

  return context;
};
